export default{
	baseUrl: "https://api-prime.imrul.xyz/api"
	// baseUrl: "http://logistic.test/api"
}